import React from 'react';
import HeroSection from '../Components/HeroSection';
import About from '../Components/About';
import Gallery from '../Components/Gallery';

const HomePage = () => {
    return (
        <>
           <HeroSection />
           <About />
           <Gallery />
        </>
    )
}

export default HomePage;
